let items = document
		 .querySelector(".header__inline-menu")
		 .querySelectorAll("details");

		  items.forEach(item => {
		    item.addEventListener("mouseover", () => {
		      item.setAttribute("open", true);
				item.querySelector("ul").addEventListener("mouseleave", () => {
				    item.removeAttribute("open");
				});
			    item.addEventListener("mouseleave", () => {
			        item.removeAttribute("open");
			    });
		  	});
		  });



 $('.testimonials-slider').slick({
  centerMode: true,
  centerPadding: '0px',
  arrows: false,
  dots: true,
  infinite: true,
  autoplaySpeed: 1500,
  autoplay: true,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 850,
      settings: {
        centerMode: true,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        centerMode: true,
        slidesToShow: 1
      }
    }
  ]
});


  
